module.exports = __webpack_public_path__ + "static/media/referral-img.fb1fd8a8.svg";